import React from 'react';
import { ArrowRight } from 'lucide-react';
import { SUPPORT_OPTIONS, WORKER } from './frontlineDemo';
import { Chip } from './bits';

const option = (s) => SUPPORT_OPTIONS.find((o) => o.id === s.support);
const note = (s) => (s.supportNotes || {})[s.support];

// What Alex asked for, in his words — shown to Alex before "Did it work?" and to Maya before she helps.
export function Baseline({ s, who = 'worker' }) {
  const o = option(s);
  if (!o) return null;
  const n = note(s);
  const bars = s.barriers.filter((b) => b !== 'Something else');
  return (
    <div className="fl-baseline" data-testid={`fl-baseline-${who}`}>
      <p className="fl-label" style={{ marginTop: 0 }}>{who === 'worker' ? 'What you asked for' : `What ${WORKER.name.split(' ')[0]} asked for`} <span className="fl-muted" style={{ fontWeight: 500, textTransform: 'none', letterSpacing: 0 }}>· baseline for “Did it work?”</span></p>
      <p className="fl-strong" style={{ margin: 0 }}>{o.title}{s.readiness && <span className="fl-muted"> · felt {s.readiness.toLowerCase()}</span>}</p>
      {n && <p className="fl-quote" data-testid={`fl-baseline-note-${who}`}>“{n}”</p>}
      {(bars.length > 0 || s.barrierNote) && <p className="fl-small" style={{ margin: '4px 0 0' }}>In the way: {bars.join(' · ')}{s.barrierNote && <> · “{s.barrierNote}”</>}</p>}
      {!n && who === 'worker' && <p className="fl-small" style={{ margin: '4px 0 0' }}>You didn't add detail to this request.</p>}
    </div>
  );
}

// After validation: Alex's ask vs what actually happened (+ Maya's observation), side by side.
export function Compare({ s }) {
  const o = option(s);
  const v = s.validation;
  if (!o || !v) return null;
  const n = note(s);
  return (
    <div className="fl-compare" data-testid="fl-compare">
      <div>
        <p className="fl-label" style={{ marginTop: 0 }}>Before · what you asked for</p>
        <p className="fl-strong" style={{ margin: 0 }}>{o.title}</p>
        {n ? <p className="fl-quote" data-testid="fl-compare-ask">“{n}”</p> : <p className="fl-small" style={{ margin: '4px 0 0' }}>No detail added</p>}
        {s.readiness && <Chip>{s.readiness}</Chip>}
      </div>
      <ArrowRight size={18} className="fl-muted fl-compare-arrow" aria-hidden="true" />
      <div>
        <p className="fl-label" style={{ marginTop: 0 }}>After · what happened</p>
        <p className="fl-strong" style={{ margin: 0 }} data-testid="fl-compare-outcome">{v.went.charAt(0) + v.went.slice(1).toLowerCase()} · {v.help === 'NONE' ? 'no help' : `${v.help.toLowerCase()} help`}</p>
        <p className="fl-small" style={{ margin: '4px 0 6px' }}>Maya: {s.observation ? `${s.observation.support.toLowerCase()} needed · approach ${s.observation.approach}/5` : 'not observed'}</p>
        <Chip accent>CONFIDENCE {v.confidence} / 5</Chip>
      </div>
    </div>
  );
}
